import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AdminCalendar from "@/pages/AdminCalendar";
import AdminLogin, { AdminGuard } from "@/pages/AdminLogin";
import SmoothScroll from "@/components/SmoothScroll";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard><Admin /></AdminGuard>} />
            <Route path="/admin/calendar" element={<AdminGuard><AdminCalendar /></AdminGuard>} />
          </Routes>
        </SmoothScroll>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#1F2A24", color: "#F5F1EA", border: "none",
              borderRadius: 0, fontFamily: "Manrope, sans-serif",
              letterSpacing: "0.04em", fontSize: "13px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
